import { render, staticRenderFns } from "./JVxePagination.vue?vue&type=template&id=1bfa023a&scoped=true"
import script from "./JVxePagination.vue?vue&type=script&lang=js"
export * from "./JVxePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfa023a",
  null
  
)

export default component.exports